<template>
    <div class="video">
        <servicesList></servicesList>
        <ul class="video_list">
            <li v-for="(n,i) in videoLists" :key="i">
                <div class="service_video">
                    <video class="video-js" controls preload="auto"
                           :poster="weburl + n.img" ta-setup="{}">
                        <source :src="weburl + n.video" type="video/mp4">
                    </video>
                </div>
                <h5>{{n.title}}</h5>
            </li>
            <!--<li>
                <div class="service_video">
                    <video class="video-js" controls preload="auto" width="164" height="96"
                           poster="" ta-setup="{}">
                        <source src="" type="video/mp4">
                    </video>
                </div>
                <h5>度假村</h5>

            </li>
            <li>
                <div class="service_video">
                    <video class="video-js" controls preload="auto" width="164" height="96"
                           poster="" ta-setup="{}">
                        <source src="" type="video/mp4">
                    </video>
                </div>
                <h5>度假村</h5>

            </li>-->
        </ul>
    </div>

</template>

<script>
    import servicesList from '../../components/services/servicesList';

    export default {
        name: "Clvideo",
        components: {
            servicesList
        },
        data: function () {
            return {
                videoLists: '',
            }
        },
        created: function () {
            this.getVideosInfo();
            this.$store.commit("set_current_index", 6);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
        },
        methods: {
            getVideosInfo: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/serve/getVideos",
                    dataType: "json",
                    data: {
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.videoLists = res.data.result
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common";

    .video_list {
        background: @bg;
        display: flex;
        flex-wrap: wrap;
        .box-sizing;
        width: @width;
        padding: 20px 15px;
        @media (max-width: 360px) {
            justify-content: center;
        }

        li {
            width: 164px;
            margin: 0 15px 20px 0;
            .box-shadow;
            background: @font-primary;
            .border-radius(5px);
            @media (max-width: 360px) {
                margin-right: 0;
                width: 274px;
            }

            &:nth-child(2n) {
                margin-right: 0;
                @media (max-width: 360px) {
                    margin-right: 0;
                }

            }
            video {
                width: 164px;
                height: 96px;
                .border-radius(5px 5px 0 0);
                margin-top: -3px;
                @media (max-width: 360px) {
                    width: 274px;
                    height: 180px;
                    margin-top: -13px;
                }
            }
        }
        h5 {
            font-size: 0.85rem;
            padding: 7px 6px 10px;
            color: @word;

        }
    }

    @media (min-width: 768px) and (orientation: portrait) {
        .video_list {
            li {
                width: 234px;
                margin: 0 15px 20px 0;
                .border-radius(5px);
                &:nth-child(2n) {
                    margin-right: 15px;
                }
                &:nth-child(3n) {
                    margin-right: 0;
                }
                video {
                    width: 233px;
                    height: 130px;
                }
            }
            h5 {
                font-size: 1.2rem;
                padding: 10px 6px 14px;
            }
        }
    }

</style>
